export default "__VITE_ASSET__CgwIeH1r__"